import React, { forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useSSRSafeId } from '@polestar/component-warehouse-react/contexts/ssr';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import Text from '@polestar/component-warehouse-react/components/text/Text';
import Emphasis from '@polestar/component-warehouse-react/tokens/emphasis/Emphasis';
export var StatusBadgeVariants;
(function (StatusBadgeVariants) {
    StatusBadgeVariants["active"] = "active";
    StatusBadgeVariants["attention"] = "attention";
    StatusBadgeVariants["default"] = "default";
    StatusBadgeVariants["inactive"] = "inactive";
    StatusBadgeVariants["pending"] = "pending";
})(StatusBadgeVariants || (StatusBadgeVariants = {}));
export const StatusBadgeVariantSizes = {
    [Sizes.medium]: {
        fontSize: FontSizes.body,
        lineHeight: LineHeights.small,
        spacing: Spacings.xSmall,
        indicatorSize: Spacings.xSmall,
    },
    [Sizes.large]: {
        fontSize: FontSizes.large,
        lineHeight: LineHeights.large,
        spacing: Spacings.small,
        indicatorSize: Spacings.xSmall,
    },
};
const StatusBadge = forwardRef(({ id, label = 'Label', status = StatusBadgeVariants.default, size = Sizes.medium, emphasis = Emphasis.low, ...props }, ref) => {
    const memoizedId = useSSRSafeId('status-badge', id);
    return (React.createElement(StatusBadgeLabel, { as: "div", id: memoizedId, ref: ref, status: status, size: size, emphasis: emphasis, lineClamp: 1, ...aria({
            role: 'status',
        }), ...props }, label));
});
StatusBadge.displayName = 'StatusBadge';
export default StatusBadge;
const StatusBadgeLabel = styled(Text)(({ status, size, emphasis, theme }) => {
    var _a, _b, _c;
    return css(css `
    color: ${emphasis === 'low'
        ? (_a = theme.statusBadge.variants[status]) === null || _a === void 0 ? void 0 : _a.textColor
        : (_b = theme.statusBadge.variants[status]) === null || _b === void 0 ? void 0 : _b.highEmphasisTextColor};
    font-size: ${StatusBadgeVariantSizes[size].fontSize};
    line-height: ${StatusBadgeVariantSizes[size].lineHeight};

    &:before {
      content: '';
      display: inline-block;
      position: relative;
      inset-block-end: ${createCustomSpacing(size === Sizes.medium ? 1 / 16 : 6 / 16)};
      width: ${StatusBadgeVariantSizes[size].indicatorSize};
      height: ${StatusBadgeVariantSizes[size].indicatorSize};
      margin-inline-end: ${StatusBadgeVariantSizes[size].spacing};
      border-radius: 50%;
      background-color: ${(_c = theme.statusBadge.variants[status]) === null || _c === void 0 ? void 0 : _c.statusColor};
    }
  `);
});
